import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { OverlayMenuComponent } from '../overlay-menu/overlay-menu.component';
import { ButtonComponent } from '../button/button.component';
import { IconName } from '../_shared/models/icon.model';
import { ILink } from '../_shared/models/link.model';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'sirius-profile-menu',
    templateUrl: './profile-menu.component.html',
    styleUrls: ['./profile-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [OverlayMenuComponent, CommonModule, ButtonComponent, TranslateModule]
})
export class ProfileMenuComponent {
    @Input() options?: { icon: IconName; link: ILink }[];
    @Output() profileMenuClicked = new EventEmitter<MouseEvent>();

    overlayId = `overlay-${uuidv4()}`;

    private _showOverlay = new BehaviorSubject<boolean>(false);
    showOverlay$ = this._showOverlay.asObservable();

    onClickIcon(event: MouseEvent): void {
        this.profileMenuClicked.emit(event);
        if (this.options) {
            this.onCloseOverlay(event);
        }
    }

    onClickOverlay(e: MouseEvent): void {
        this.onCloseOverlay(e);
    }

    onCloseOverlay(e: Event): void {
        const currentTarget = e.currentTarget as HTMLElement;
        const showOverlay: boolean = this._showOverlay.value;

        if (!showOverlay && e.type === 'focusout') {
            return;
        }

        // Prevents the overlay reopening if the button is used to close it.
        const relatedTarget = (e as MouseEvent).relatedTarget as HTMLElement | null;
        if (
            relatedTarget?.getAttribute('aria-controls') === this.overlayId &&
            currentTarget.tagName === 'SIRIUS-OVERLAY-MENU'
        ) {
            return;
        }

        this._showOverlay.next(!showOverlay);
    }
}
